import React from 'react'
import { Route } from 'react-router-dom'

import InstructorsCoursePage from './instructors/InstructorsCoursePage'

import StudentProfile from './students/StudentProfile'
import StudentCredits from './students/StudentCredits'
import StudentCoursePage from './students/StudentCoursePage'

import Register from './auth/registerPage'
import ForgotPage from './auth/forgotPage'

export default [
  <Route exact path="/profile" component={StudentProfile} />,
  <Route path="/course/in-progress/:id" component={StudentCoursePage} />,
  <Route path="/course/show/:id" component={StudentCoursePage} />,
  <Route path="/course/join/:id" component={StudentCoursePage} />,
  <Route path="/course/instructor/:id" component={InstructorsCoursePage} />,
  <Route path="/course/admin/:id" component={InstructorsCoursePage} />,
  <Route path="/register" component={Register} noLayout />,
  <Route path="/forgot" component={ForgotPage} noLayout />,
]



// WEBPACK FOOTER //
// ./src/customRoutes.js